import React from 'react';
import {
  Dashboard as DashboardIcon,
  Apps as AppsIcon,
  Work as WorkIcon,
  People as PeopleIcon,
  ShoppingCart as ShoppingCartIcon,
  Campaign as CampaignIcon,
  AccountBalance as FinanceIcon,
  Settings as SettingsIcon,
  Assignment as AssignmentIcon,
  HealthAndSafety as InsuranceIcon,
  EventNote as LeaveIcon,
  WhatsApp as WhatsAppIcon,
  Assessment as ReportIcon,
  Receipt as InvoiceIcon,
} from '@mui/icons-material';

export interface DashboardModule {
  id: string;
  titleKey: string;
  descriptionKey: string;
  path: string;
  icon: React.ReactNode;
  color: string;
  bgLight: string;
}

export const dashboardModules: DashboardModule[] = [
  {
    id: 'reports',
    titleKey: 'navigation.reports',
    descriptionKey: 'dashboard.modules.reportsDesc',
    path: '/reports',
    icon: <AppsIcon />,
    color: '#6366f1',
    bgLight: '#eef2ff',
  },
  {
    id: 'operations',
    titleKey: 'navigation.operations',
    descriptionKey: 'dashboard.modules.operationsDesc',
    path: '/operations/overview',
    icon: <WorkIcon />,
    color: '#0ea5e9',
    bgLight: '#e0f2fe',
  },
  {
    id: 'organization',
    titleKey: 'navigation.organization',
    descriptionKey: 'dashboard.modules.hrDesc',
    path: '/organization/overview',
    icon: <PeopleIcon />,
    color: '#8b5cf6',
    bgLight: '#ede9fe',
  },
  {
    id: 'sales-crm',
    titleKey: 'navigation.salesCRM',
    descriptionKey: 'dashboard.modules.salesDesc',
    path: '/sales/overview',
    icon: <ShoppingCartIcon />,
    color: '#f59e0b',
    bgLight: '#fef3c7',
  },
  {
    id: 'marketing',
    titleKey: 'navigation.marketing',
    descriptionKey: 'dashboard.modules.marketingDesc',
    path: '/marketing/overview',
    icon: <CampaignIcon />,
    color: '#ec4899',
    bgLight: '#fce7f3',
  },
  {
    id: 'finance',
    titleKey: 'navigation.finance',
    descriptionKey: 'dashboard.modules.financeDesc',
    path: '/finance/overview',
    icon: <FinanceIcon />,
    color: '#10b981',
    bgLight: '#d1fae5',
  },
  {
    id: 'operations-requests',
    titleKey: 'navigation.requests',
    descriptionKey: 'dashboard.modules.requestsDesc',
    path: '/requests',
    icon: <AssignmentIcon />,
    color: '#ef4444',
    bgLight: '#fee2e2',
  },
  {
    id: 'operations',
    titleKey: 'navigation.insuranceClients',
    descriptionKey: 'dashboard.modules.insuranceDesc',
    path: '/insurance-clients',
    icon: <InsuranceIcon />,
    color: '#14b8a6',
    bgLight: '#ccfbf1',
  },
  {
    id: 'organization',
    titleKey: 'navigation.leaveRequests',
    descriptionKey: 'dashboard.modules.leaveDesc',
    path: '/leave-requests',
    icon: <LeaveIcon />,
    color: '#a855f7',
    bgLight: '#f3e8ff',
  },
  {
    id: 'operations',
    titleKey: 'navigation.whatsappChat',
    descriptionKey: 'dashboard.modules.whatsappDesc',
    path: '/operations/whatsapp-chat',
    icon: <WhatsAppIcon />,
    color: '#22c55e',
    bgLight: '#dcfce7',
  },
  {
    id: 'finance',
    titleKey: 'navigation.invoices',
    descriptionKey: 'dashboard.modules.invoicesDesc',
    path: '/invoices',
    icon: <InvoiceIcon />,
    color: '#3b82f6',
    bgLight: '#dbeafe',
  },
  {
    id: 'operations',
    titleKey: 'navigation.requestItemsReport',
    descriptionKey: 'dashboard.modules.reportDesc',
    path: '/requests/report',
    icon: <ReportIcon />,
    color: '#64748b',
    bgLight: '#f1f5f9',
  },
  {
    id: 'settings',
    titleKey: 'navigation.settings',
    descriptionKey: 'dashboard.modules.settingsDesc',
    path: '/settings',
    icon: <SettingsIcon />,
    color: '#475569',
    bgLight: '#e2e8f0',
  },
];

export const dashboardHomeModule: DashboardModule = {
  id: 'dashboard',
  titleKey: 'navigation.dashboard',
  descriptionKey: 'dashboard.modules.dashboardDesc',
  path: '/dashboard',
  icon: <DashboardIcon />,
  color: '#F56A2C',
  bgLight: '#fff7ed',
};
